var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isSequentialProgram)?_c('MyMenteeModuleTasks',{attrs:{"id":_vm.id,"mentee":_vm.mentee,"menteeId":_vm.menteeId}}):_c('MyMenteeGoalTasks',{attrs:{"id":_vm.id,"mentee":_vm.mentee,"menteeId":_vm.menteeId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }